var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEthereum = function SvgEthereum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9336 12.1235L12 15.7485L6.0625 12.1235L12 1.93604L17.9336 12.1235ZM12 16.9126L6.0625 13.2876L12 21.936L17.9375 13.2876L12 16.9126Z",
    fill: "#037DD6"
  })));
};
export default SvgEthereum;